import { createAsyncThunk } from "@reduxjs/toolkit";

import { addPortCallNotification, getPortCallNotification } from "../../apis/portCallNotification";

export const addPortCallNotificationData = createAsyncThunk("postPortCall/addPortCallNotification", async({ agentOnly, hqOnly, email_introduction, pcid,attachmentList, includeCC }: { agentOnly: boolean; hqOnly: boolean; email_introduction: string; pcid: string, attachmentList:any, includeCC:boolean},
    { rejectWithValue })=>{
    try {
        // Call the correct API function with optional parameters
        const response = await addPortCallNotification({
        agentOnly,
        hqOnly,
        includeCC,
        email_introduction,
        attachmentList,
        pcid,
    });
      return response.data;
    } catch (error: any) {
        return rejectWithValue(error);
    }
})

export const getPortCallNotificationData = createAsyncThunk(
  "getPortCall/getPortCallNotification",
  async (
    { agentOnly, hqOnly, showCompletedBerth, pcid }: { agentOnly: boolean; hqOnly: boolean; showCompletedBerth: boolean; pcid: string },
    { rejectWithValue }
  ) => {
    try {
      // Pass the parameters to the API function
      const response = await getPortCallNotification({
        agentOnly,
        hqOnly,
        showCompletedBerth,
        pcid,
      });
      return response.data;
    } catch (error: any) {
      console.error("Error fetching port call notification:", error);
      return rejectWithValue(error.message || "Failed to fetch port call notification");
    }
  }
);